import { formatDashDate } from '../../helpers/StringNumberFunction/formatDate'

export const advancedFilterList = list => {
  const advancedFilter = JSON.parse(localStorage.getItem('advancedFilter'))
  let newList = list
  if (advancedFilter && Object.keys(advancedFilter)?.length > 0) {
    newList = list?.filter(e => {
      let date =
        new Date(e?.DocDate) ?? e?.createdTs ?? e?.JournalDate ?? e?.DueDate
      if (!!advancedFilter?.DocDate) {
        return e?.DocDate === formatDashDate(advancedFilter?.DocDate)
      } else if (!!advancedFilter?.toDate && !!advancedFilter?.fromDate) {
        return (
          new Date(date) >= new Date(advancedFilter?.fromDate) &&
          new Date(date) <= new Date(advancedFilter?.toDate)
        )
      } else {
        return e
      }
    })
  }
  return newList
}

export const journalFilterList = (list = []) => {
  const journal = JSON.parse(localStorage.getItem('externalJournalFilter'))
  let newList = [...list]

  if (journal && Object.keys(journal)?.length > 0) {
    if (journal.mode === 'journal-enquiry') {
      if (journal?.JournalNo) {
        newList = newList.filter(e =>
          (e?.JournalNo || '')
            .toLowerCase()
            .includes(journal.JournalNo.toLowerCase())
        )
      }
      if (journal?.RefNo) {
        newList = newList.filter(e =>
          (e?.RefNo || '').toLowerCase().includes(journal.RefNo.toLowerCase())
        )
      }
      if (journal?.Description) {
        newList = newList.filter(e =>
          (e?.Description || '')
            .toLowerCase()
            .includes(journal.Description.toLowerCase())
        )
      }
    } else {
      newList = list?.filter(e => {
        let date =
          new Date(e?.DocDate) ?? e?.createdTs ?? e?.JournalDate ?? e?.DueDate

        if (!!journal?.DocDate) {
          return e?.DocDate === formatDashDate(journal?.DocDate)
        } else if (!!journal?.toDate && !!journal?.fromDate) {
          return (
            new Date(date) >= new Date(journal?.fromDate) &&
            new Date(date) <= new Date(journal?.toDate)
          )
        } else {
          return e
        }
      })
    }
  }

  return newList
}
